<h4 class="f-w-700 f-s-24 m-t-24 m-b-8">{{"recovery_password.recovery_password" | translate}}</h4>
<span class="f-s-14 d-block f-s-14 m-t-8">
  {{"recovery_password.sent_recovery_password" | translate}}
</span>
